var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.06,
    height: 15.084,
    viewBox: "0 0 17.06 15.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488400",
    "data-name": "Group 488400",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180812",
    "data-name": "Path 180812",
    d: "M153.367,195.873c-.463,0-.891,0-1.319,0a3.047,3.047,0,0,1-.568-6.04c.193-.037.271-.1.3-.312a5.627,5.627,0,0,1,10.75-1.527.5.5,0,0,0,.417.354,3.785,3.785,0,0,1,.226,7.409,11.376,11.376,0,0,1-1.32.164c-.005.065-.02.167-.02.269,0,.647,0,1.294,0,1.942a1.458,1.458,0,0,1-1.551,1.554q-2.679,0-5.357,0a1.45,1.45,0,0,1-1.552-1.517C153.356,197.417,153.367,196.665,153.367,195.873Zm8.455-.836a11.022,11.022,0,0,0,1.1-.1,2.916,2.916,0,0,0-.335-5.752.75.75,0,0,1-.751-.57,4.759,4.759,0,0,0-9.221,1.314c-.048.615-.1.652-.661.7a2.125,2.125,0,0,0-1.841,1.246,2.091,2.091,0,0,0,.188,2.211,2.856,2.856,0,0,0,3.067.86c0-.522-.007-1.049,0-1.576a1.471,1.471,0,0,1,.978-1.445c.142-.048.291-.076.428-.111.116-2.062,1.074-3.228,2.655-3.283a2.789,2.789,0,0,1,2.018.694,2.931,2.931,0,0,1,.946,2.584,1.543,1.543,0,0,1,1.428,1.772C161.823,194.046,161.822,194.51,161.822,195.038Zm-4.229-2.33c-.886,0-1.772,0-2.658,0-.486,0-.709.214-.711.695q-.007,2.353,0,4.706c0,.477.228.7.713.7q2.658.007,5.316,0a.62.62,0,0,0,.711-.7q.007-2.353,0-4.706c0-.478-.229-.692-.713-.693C159.365,192.706,158.479,192.708,157.593,192.708Zm1.908-.88a2.025,2.025,0,0,0-.93-2.173,1.94,1.94,0,0,0-2.16.137,1.979,1.979,0,0,0-.706,2.036Z",
    transform: "translate(-149.016 -184.603)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180814",
    "data-name": "Path 180814",
    d: "M252.5,319.113a1.121,1.121,0,0,1,1.184.838,1.16,1.16,0,0,1-.548,1.32.657.657,0,0,0-.189.327,1.253,1.253,0,0,0-.008.285.4.4,0,0,1-.437.419.383.383,0,0,1-.415-.435.712.712,0,0,0-.381-.746,1.063,1.063,0,0,1-.346-1.254A1.126,1.126,0,0,1,252.5,319.113Zm.423,1.174c-.182-.146-.289-.3-.377-.285-.115.014-.215.154-.322.24.084.1.16.269.254.279C252.59,320.533,252.715,320.406,252.926,320.287Z",
    transform: "translate(-243.934 -309.436)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8b79390f7658b94e1ead00dde132c89d.svg";
export { ForwardRef as ReactComponent };